import * as React from 'react';
import MainPage from '../components/pages/MainPage';

export default () => <MainPage/>;

